import { useQuery } from '@tanstack/react-query';
import { useGraphQLClient } from 'hooks';

const useGetLeaderboardProgress = () => {
  const { graphql, graphQLClient, hasToken } = useGraphQLClient();

  const getLeaderboardProgressSql = graphql(`
    query GetLeaderboardProgress {
      leaderboardProgress {
        pickATrack
        joinLeaderboard
        climbRanks
        dailyTournament
        weeklyTournament
      }
    }
  `);

  const getLeaderboardProgress = useQuery({
    enabled: Boolean(hasToken),
    queryKey: ['getLeaderboardProgress'],
    queryFn: async () => {
      return graphQLClient.request(getLeaderboardProgressSql);
    },
    staleTime: 1000 * 60 * 15,
  });
  return getLeaderboardProgress;
};

export default useGetLeaderboardProgress;
